import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import { translate } from '@/util/commonFun'
import { regReplaceBluenPtpDealNumber } from '@/util/regReplace'
import { IEditableFields } from '@/views/materialsList/types/material'
import { computed, reactive, ref, watch } from 'vue'

interface PropsType {
  editerVisibel: boolean
  isLoading: boolean
  extraWarningTips?: string[]
}
interface FormState {
  prop: IEditableFields
  isAllRows: boolean
  editValue: string | number | undefined | boolean
}

/** vuex 偏好设置 */

export default /*#__PURE__*/_defineComponent({
  __name: 'm-plank-editer',
  props: {
    editerVisibel: { type: Boolean },
    isLoading: { type: Boolean },
    extraWarningTips: { default: () => [] }
  },
  emits: ["onConfirm", "onCancel"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onConfirm', form: FormState): void
  (e: 'onCancel', payload?: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { editerVisibel: boolean, isLoading: boolean, extraWarningTips: string[] }

const preferencesSetting = computed(
  () => store.state.preferencesSetting?.setting
)

const texDirOptions = [
  {
    label: 'common.reverse',
    value: 'reverse',
  },
  {
    label: 'common.normal',
    value: 'normal',
  },
  {
    label: 'common.notCare',
    value: 'notcare',
  },
]

const typeOptions = [
  {
    label: 'common.isDoorPlank',
    value: 'SingleDoor',
  },
  {
    label: 'common.notDoorPlank',
    value: 'Plank',
  },
]

// 高光属性
const highLightProps = [
  {
    label: '高光',
    value: 1,
  },
  {
    label: '非高光',
    value: 0,
  },
]

const deleteHolesSlotsDataList = ref([
  'specHeight',
  'specWidth',
  'leftEdge',
  'rightEdge',
  'frontEdge',
  'backEdge',
  'allEdge',
  'thick',
])




const isShow = ref<boolean>(props.editerVisibel)
const contentOptions = ref<{ label: string; value: any }[]>(texDirOptions)
const formState: FormState = reactive({
  prop: 'matCode',
  isAllRows: false,
  editValue: '',
})
let isShowWarning = ref<boolean>(false)
const extraTips = computed(() => [...new Set(props.extraWarningTips)])

// 不需要批量修改的属性
const excludeProps = [
  'select',
  'plankID',
  'hsInfo',
  'specialShape',
  'partName',
  'plankNum', //板件条码不允许修改
  'hingeInfo',
  'process_label',
  'finishedArea', // 成品面积由长宽自动计算，不允许直接修改
  'textureGrainInfo', // 对纹组不允许批量修改
] as const
const editProps = computed(() => {
  if (preferencesSetting.value?.needSaveData) {
    let propArr = preferencesSetting.value?.needSaveData.filter(
      (prop: any) => !excludeProps.includes(prop.prop)
    )
    propArr.push({
      prop: 'allEdge',
      headSlotName: 'headAllEdge',
      label: 'materialPage.edit.allEdge',
      interactionType: 'input',
      widthType: 'width',
      width: '70px',
      minWidth: '30px',
      temp: '0',
      maxWidth: '150px',
      customLabel: 'materialPage.edit.allEdge',
    })
    return propArr
  } else {
    return []
  }
  return []
})

function translateLang(key: string) {
  return translate(key)
}

// 确认
function handleConfirm() {
  emits('onConfirm', formState)
}

// 取消
function handleCancel() {
  emits('onCancel')
}

function handleChangeEditProp() {
  isShowWarning.value = deleteHolesSlotsDataList.value.includes(formState.prop)
  if (
    !['leftEdge', 'rightEdge', 'frontEdge', 'backEdge', 'allEdge'].includes(
      formState.prop
    )
  ) {
    extraTips.value = []
  }
  switch (formState.prop) {
    case 'texDir':
      contentOptions.value = texDirOptions
      formState.editValue = 'notcare'
      break
    case 'type':
      contentOptions.value = typeOptions
      formState.editValue = 'Plank'
      break
    case 'is_high_gloss_plank':
      contentOptions.value = highLightProps
      formState.editValue = 1
      break
    default:
      formState.editValue = ''
      break
  }
}

function inputChange() {
  if (formState.editValue) {
    formState.editValue = String(formState.editValue).slice(0, 25)
    if (['partName', 'matCode', 'texture'].includes(formState.prop)) {
      formState.editValue = String(formState.editValue).slice(0, 25)
    } else if (formState.prop === 'amount') {
      formState.editValue = parseInt(
        regReplaceBluenPtpDealNumber(formState.editValue)
      )
    } else {
      formState.editValue = String(formState.editValue).slice(0, 25)
    }
  }
}

watch(
  () => props.editerVisibel,
  (val) => {
    isShow.value = val
  }
)

watch(
  () => isShow.value,
  (val) => {
    if (!val) {
      emits('onCancel', true)
    }
  }
)

return { __sfc: true,preferencesSetting, texDirOptions, typeOptions, highLightProps, deleteHolesSlotsDataList, props, emits, isShow, contentOptions, formState, isShowWarning, extraTips, excludeProps, editProps, translateLang, handleConfirm, handleCancel, handleChangeEditProp, inputChange }
}

})